import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "@core/auth/auth.service";
import { environment } from "environments/environment";
import { firstValueFrom, Observable, Subject } from "rxjs";

export interface SelectParams {
    modelo: string;
    campo_id: string;
    campo_descripcion: string;
    campo_activo?: string;
    where?: string; //Filtra qué registros traer where: 'localidad=3'
    return?: string; //Define formato de respuesta 'object' o 'array'
}
const BASE_REST = environment.baseRest;
@Injectable({
    providedIn: 'root'
})
export class SelectsService {
    constructor(
        private _httpClient: HttpClient,
        private _authService: AuthService
    ) {}

    private buildUrl(params: SelectParams): string {
        const query = new URLSearchParams();
        query.set('modelo', params.modelo);
        query.set('campo_id', params.campo_id);
        query.set('campo_descripcion', params.campo_descripcion);

        if (params.campo_activo !== undefined) query.set('campo_activo', params.campo_activo);
        if (params.where) query.set('where', params.where);
        if (params.return) query.set('return', params.return);

        return `${BASE_REST}/select?${query.toString()}`;
    }

    getSelect(params: SelectParams): Observable<any> {
        return this._httpClient.get<any>(this.buildUrl(params));
    }

    // Shortcut para el componente, solo agrega parámetros si están definidos
    getSelectByModel<T>(
        modelo: string,
        campo_id: string,
        campo_descripcion: string,
        options?: { campo_activo?: string; where?: string; returnFormat?: string }
    ): Promise<T[]> {
        const params: SelectParams = {
            modelo,
            campo_id,
            campo_descripcion
        };

        if (options?.campo_activo) params.campo_activo = options.campo_activo;
        if (options?.where) params.where = options.where;
        if (options?.returnFormat) params.return = options.returnFormat;

        return firstValueFrom(this.getSelect(params))
            .then(res => {
                if (res.token) {
                    this._authService.accessToken = res.token;
                }
                return res.list ?? res.result ?? res;
            }); 
    }
}